module.exports = "/images/betalabs.png?5f02ed4796a2188a72927cd293c0722b";